import React from 'react';
import './CatalogueMobileExperiences.css';

const CatalogueMobileExperiences = () => {
    const experiences = [
        {
            id: 1,
            title: 'Project Overview (MR)',
            image: '/images/catalogueimage01.webp',
        },
        {
            id: 2,
            title: 'Unit & View Selection (VR)',
            image: '/images/catalogueimage02.webp',
        },
        {
            id: 3,
            title: 'Apartment walk through',
            image: '/images/catalogueimage03.webp',
        },
    ];

    return (
        <div className="catalogue-mobile-experiences">
            <h2 className="catalogue-experiences-title">KEY BUYER EXPERIENCES</h2>

            <div className="catalogue-experiences-container">
                {experiences.map((exp) => (
                    <div key={exp.id} className="catalogue-experience-card">
                        <div className="catalogue-experience-label">
                            <span>{exp.title}</span>
                        </div>
                        <div className="catalogue-experience-image-wrapper">
                            <img src={exp.image} alt={exp.title} className="catalogue-experience-image" />
                        </div>
                    </div>
                ))}
            </div>

            <div className="catalogue-experiences-footer">
                <p className="catalogue-footer-promo">"15-minute demo available at your doorstep"</p>
                <p className="catalogue-footer-contact">DM +91 9769012101</p>
            </div>
        </div>
    );
};

export default CatalogueMobileExperiences;
